import style from './loader.module.scss';

export const Loader = () => {
  return (
    <div className={style.loader_container}>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
      <div className={style.loader}></div>
    </div>
  );
};
